module.exports = __webpack_public_path__ + "img/ennetix-xome-tab2.adbfb13b.png";